import { isObject } from '@atlassiansox/bxp-shared-utils';
import { isCSSUnits } from './css-units';
export function isSizeType(value) {
    return ['keyword', 'units'].includes(value);
}
export function isSizeKeyword(value) {
    return ['auto', 'cover', 'contain', 'initial', 'inherit'].includes(value);
}
export function isSize(value) {
    if (!isObject(value)) {
        return false;
    }
    const temp = value;
    return (isSizeType(temp.fieldType) &&
        isSizeKeyword(temp.keyword) &&
        isObject(temp.units) &&
        isCSSUnits(temp.units.unit) &&
        typeof temp.units.width === 'number' &&
        typeof temp.units.height === 'number' &&
        typeof temp.units.isAutoWidth === 'boolean' &&
        typeof temp.units.isAutoHeight === 'boolean');
}
//# sourceMappingURL=size.js.map